import { ArrowLeft } from '@/components/icons'
import { Button } from '../ui/button'
import { ReactNode } from 'react'
import { useBackOrHome } from './useBackOrHome'
import { cn } from '@/lib/utils'

interface TopBarBackIconButtonProps {
  title?: string
  icon?: ReactNode
  onIconClick?: () => void
  className?: string
  rightElement?: ReactNode
  showBackButton?: boolean
  /** Overrides the default back action (history back, or home when empty). */
  onBack?: () => void
}

export function TopBarBackIconButton({
  title,
  icon,
  onIconClick,
  rightElement,
  showBackButton = true,
  className,
  onBack: onBackOverride,
}: TopBarBackIconButtonProps) {
  const backOrHome = useBackOrHome()
  const onBack = onBackOverride ?? backOrHome

  return (
    <>
      {/* Spacer to reserve space in document flow */}
      <div className="shrink-0 safe-top"><div className="h-16" /></div>
      {/* Fixed header */}
      <div className={cn('fixed top-0 left-0 right-0 z-50 safe-top bg-surface-brand-L0', className)}>
        <div className="content-frame px-gutter py-4 flex items-center justify-between">
        {/* Left: Back Button + Title */}
        <div className="flex items-center gap-3">
          {showBackButton && (
            <Button
              variant={'outline'}
              size="sm"
              roundness="round"
              onClick={onBack}
              className={`size-8 p-0 bg-content-primary-inverse hover:bg-content-primary-inverse/30 border-0 text-content-primary-bold`}
            >
              <ArrowLeft className="size-5" />
            </Button>
          )}
          {title && (
            <h1 className={`text-xl font-semibold text-content-primary-bold`}>{title}</h1>
          )}
        </div>

        {/* Right: Custom element or Icon Button */}
        {rightElement ? (
          rightElement
        ) : icon ? (
          <Button
            variant={'outline'}
            size="sm"
            roundness="round"
            onClick={onIconClick}
            className={`size-8 p-0 bg-content-primary-inverse hover:bg-content-primary-inverse/30 border-0`}
          >
            {icon}
          </Button>
        ) : null}
        </div>
      </div>
    </>
  )
}
